// extracted by mini-css-extract-plugin
export default {"active":"RequestTable_active__Cf3DJ","inactive":"RequestTable_inactive__bfBLQ","revoked":"RequestTable_revoked__Zajfh"};